module.exports = __webpack_public_path__ + "img/boleto.946ff3be.svg";